import axios from "axios";
import { iNft } from "./nft";
import { BookingEngine } from "./collection";

export enum DATA_ANALYSIS_MODULE_TYPE {
  BASE = "base",
  REVENUE = "revenue",
  APPRECIATION = "appreciation",
  PERFORMANCE = "performance",
  NFT = "nft",
  CUSTOMER = "customer",

  SEARCH = "search",
  TRAFFIC = "traffic",
  TRAFFIC_VALUE = "traffic_value",
  CITY_TRAFFIC = "city_traffic",
  IMPRESSION = "impression",
  REACH = "reach",

  LOYALTY = "loyalty",
  TAG_SEARCH = "tag_search",
}

export type searchConfig = {};
export type searchResponse = {
  data?: {
    day: number;
    month: number;
    year: number;
    amount: number;
  }[];
  total?: number;
};

export type trafficConfig = {};
export type trafficResponse = {
  amount?: number;
};

export type cityTrafficConfig = {};
export type cityTrafficResponse = {
  data?: {
    day: number;
    month: number;
    year: number;
    amount: number;
  }[];
  total?: number;
};

export type tagTrafficConfig = {};
export type tagTrafficResponse = {
  data?: {
    day: number;
    month: number;
    year: number;
    amount: number;
  }[];
  total?: number;
};

export type trafficValueConfig = {};
export type trafficValueResponse = {
  amount?: number;
};

export type impressionConfig = {};
export type impressionResponse = {
  data?: {
    month: number;
    year: number;
    day: number;
    impressionAmount: number;
    searchAmount: number;
    reachAmount: number;
  }[];
  total?: number;
  totalReach?: number;
};

export type baseConfig = {};
export type baseResponse = {
  nftAmount?: number;
  grossAmount?: number;
  averageBookingWindow?: number;
  roomNights?: number;
  averageDailyRate?: number;
  averageBookingPrice?: number;
  averageLenghtOfStay?: number;
};

export type revenueConfig = {};
export type revenueResponse = {
  value?: number;
  delta?: number;
};

export type appreciationConfig = {};
export type appreciationResponse = {
  value?: number;
  delta?: number;
};

export type performanceConfig = {};
export type performanceResponse = {
  conversionRatePreTakyon?: number;
  conversionRatePostTakyon?: number;
  conversionRatePostTakyonOnTakyonRateOnly?: number;
  clickOnTakyonRate?: number;
  clickOnOtherRate?: number;
  traffic?: number;
  otaSavings?: number;
};

export type nftConfig = {};
export type nftResponse = {
  nfts?: iNft[];
  bookingsAmount?: {
    month: number;
    year: number;
    takyon: number; // the n of taks from the script
    takscript: number; // the n of taks from database
    other: number;
  }[];
  nftsForSale?: iNft[];
};

export type customerConfig = {};
export type customerResponse = {
  devices?: {
    mobile?: number;
    desktop?: number;
    tablet?: number;
  };
  countries?: {
    [key in string]?: number;
  };
  people?: {
    single?: number;
    couple?: number;
    group?: number;
    family?: number;
  };
};

export type loyaltyConfig = {};
export type loyaltyResponse = {
  nftAmount?: number;
  grossAmount?: number;
  nfts?: iNft[];
};

export type maskDataModuleResponse =
  | searchResponse
  | trafficResponse
  | cityTrafficResponse
  | tagTrafficResponse
  | trafficValueResponse
  | impressionResponse
  | baseResponse
  | revenueResponse
  | appreciationResponse
  | performanceResponse
  | nftResponse
  | customerResponse
  | loyaltyResponse;

export type DataAnalysisModule =
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.SEARCH;
      config: searchConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.TRAFFIC;
      config: trafficConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.CITY_TRAFFIC;
      config: trafficConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.TAG_SEARCH;
      config: tagTrafficConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.TRAFFIC_VALUE;
      config: trafficValueConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.IMPRESSION;
      config: impressionConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.BASE;
      config: baseConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.REVENUE;
      config: revenueConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.APPRECIATION;
      config: appreciationConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.PERFORMANCE;
      config: performanceConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.NFT;
      config: nftConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.CUSTOMER;
      config: customerConfig;
    }
  | {
      name: DATA_ANALYSIS_MODULE_TYPE.LOYALTY;
      config: loyaltyConfig;
    };

export type MaskDataResponse = {
  [key in DATA_ANALYSIS_MODULE_TYPE]?: maskDataModuleResponse;
};

export type ARIDataResponse = {
  actives: number;
  activeIntegrated: number;
  totCollections: number;
  totIntegrated: number;
  tableData: {
    _id: string;
    name: string;
    bookingEngine: string;
    bookingEngineHits: number;
    bookingEngineMisses: number;
  }[];
  totHits: number;
  totMisses: number;
  integratedBookingEngines: BookingEngine[];
};

export default interface iDataAnalysisMask {
  _id: string;
  _updatedAt: string;
  name: string;
  modules: DataAnalysisModule[];
}

export async function getAnalysisMaskData(params: {
  collectionId: string;
  period?: number;
}): Promise<MaskDataResponse> {
  const res = await axios.get("/dataanalysismask/data", { params });
  return res.data;
}

export async function getARIData(params: {
  range?: number;
}): Promise<ARIDataResponse> {
  const res = await axios.get("/dataanalysismask/aridata", { params });
  return res.data;
}
